import { Component, OnInit, Input, Output, EventEmitter, ViewChildren, SimpleChanges, TemplateRef} from '@angular/core';

import * as _ from 'lodash';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';
import { CouponsService } from 'src/app/modules/retailer/services/coupons.service';

@Component({
  selector: 'app-create-coupon-set-details',
  templateUrl: './create-coupon-set-details.component.html',
  styleUrls: ['./create-coupon-set-details.component.scss']
})
export class CreateCouponSetDetailsComponent implements OnInit {

  @Input() module: string; // (CPG/RETAILER)
  @Output() navigation = new EventEmitter(); // Navigation click event

  public loginData: any;
  public couponData: any;

  public masterFormModal: BsModalRef;
  public masterFormModalData: any;

  public categories: any = [];
  public categorySelectionSettings: IDropdownSettings;
  public categorySelectionDisabled: boolean;

  public manufacturers: any = [];
  public manufacturersLoading: boolean = false;

  public brands: any = [];
  public brandsLoading: boolean = false;

  public couponTypes: any = [];
  public couponTypesLoading = false;

  public couponDetails: any = {
    categories: [],
    manufacturer: {},
    brand: {},
    discount_type_id: '',
    dollar_discount_compare: 0,
    discount_value_lower: '',
    discount_value_upper: '',
    title: '',
    description: '',
    uploadedImage: ''
  }
  public couponImageFiles: File[] = [];
  public couponImageUploading = false;

  constructor(
    private _utilService: UtilService,
    private _couponsService: CouponsService,
    private _modalService: BsModalService,
  ) { }

  ngOnInit(): void {
    this.getStorageData();
  }

  async getStorageData() {
    if (this.module == 'CPG') {
      this.loginData = await this._utilService.getStorageData('C_LOGIN');
      this.couponData = await this._utilService.getStorageData('C_NEW_COUPON');
    } else if (this.module == 'RETAILER') {
      this.loginData = await this._utilService.getStorageData('R_LOGIN');
      this.couponData = await this._utilService.getStorageData('R_NEW_COUPON');
    }

    // Set info already selected
    if (this.couponData) {
      if (this.couponData.details) {
        this.couponDetails = this.couponData.details;
      }
    }

    // Category selection settings
    this.categorySelectionSettings = {
      singleSelection: false,
      idField: 'category_id',
      textField: 'category_name',
      selectAllText: 'Select All Categories',
      unSelectAllText: 'UnSelect All Categories',
      //itemsShowLimit: 3,
      allowSearchFilter: false,
      enableCheckAll: false
    };

    this.getCategories();
    this.getManufacturers();
    this.getCouponTypes();
  }

  // Show master form modal
  async showMasterFormModal(mode: string, title: string, template: TemplateRef<any>) {
    // Reset data
    this.masterFormModalData = {
      mode: mode,
      title: title
    };

    this.masterFormModal = this._modalService.show(template, {class: 'modal-lg'});
  }

  // Hide master form modal
  hideMasterFormModal(): void {
    this.masterFormModal.hide();
  }

  // Master form actions
  masterFormActions(mode: string, event: any) {
    if (mode == 'category' && event.action == 'added') { // Reload category list
      this.getCategories();
    } else if (mode == 'manufacturer' && event.action == 'added') { // Reload manufacturer list
      this.getManufacturers();
    } else if (mode == 'brand' && event.action == 'added') { // Reload brand list
      this.getBrands();
    }

    this.hideMasterFormModal();
  }

  // Get categories
  getCategories() {
    this.categories = [];
    this.categorySelectionDisabled = true;

    this._couponsService.getCategories(this.loginData.token, this.loginData.user_details.provider_type, this.loginData.user_details.provider_id).subscribe(async getCategoriesResponse => {
      this.categorySelectionDisabled = false;
      
      if (getCategoriesResponse.status === true) { // Success
        this.categories = getCategoriesResponse.categories;
      } else {
        this._utilService.showToast(getCategoriesResponse.message, '', 'error', {});
      }
    }, error2 => { // Error from getCouponTypes
      this.categorySelectionDisabled = false;
    });
  }

  // Get manufacturers
  getManufacturers() {
    this.manufacturers = [];
    this.manufacturersLoading = true;

    this._couponsService.getManufacturers(this.loginData.token, this.loginData.user_details.provider_type, this.loginData.user_details.provider_id, false).subscribe(async getManufacturersResponse => {
      this.manufacturersLoading = false;

      if (getManufacturersResponse.status === true) { // Success
        this.manufacturers = getManufacturersResponse.manufacturers;
      } else {
        this._utilService.showToast(getManufacturersResponse.message, '', 'error', {});
      }
    }, error2 => { // Error from getCouponTypes
      this.manufacturersLoading = false;
    });
  }

  // On Category select
  /*onCategorySelect(category: any) {
    this.couponDetails.categories.push(category);
  }*/

  // On Category deselect
  onCategoryDeSelect(category: any) {
    this.couponDetails.categories = _.filter(this.couponDetails.categories, obj => obj.category_id != category.category_id);
  }

  // Manufacturer change
  onManufacturerChange(event: any) {
    this.getBrands();
  }

  // Get brands
  getBrands() {
    this.brands = [];
    this.brandsLoading = true;

    this._couponsService.getBrands(this.loginData.token, this.loginData.user_details.provider_type, this.loginData.user_details.provider_id, this.couponDetails.manufacturer.mfg_id).subscribe(async getBrandsResponse => {
      this.brandsLoading = false;

      if (getBrandsResponse.status === true) { // Success
        this.brands = getBrandsResponse.brands;
      } else {
        this._utilService.showToast(getBrandsResponse.message, '', 'error', {});
      }
    }, error2 => { // Error from getCouponTypes
      this.brandsLoading = false;
    });
  }

  // Get coupon types
  getCouponTypes() {
    this.couponTypes = [];
    this.couponTypesLoading = true;

    this._couponsService.getCouponTypes(this.loginData.token).subscribe(async getCouponTypesResponse => {
      this.couponTypesLoading = false;

      if (getCouponTypesResponse.status === true) { // Success
        this.couponTypes = getCouponTypesResponse.coupon_types;
      } else {
        this._utilService.showToast(getCouponTypesResponse.message, '', 'error', {});
      }
    }, error2 => { // Error from getCouponTypes
      this.couponTypesLoading = false;
    });
  }

  // on discount type change
  onDiscountTypeChange(event: any) {
    if (event.target.id == 'coupon_type_chk_1') { // $
      this.couponDetails.discount_type_id = 1;
    } else if (event.target.id == 'coupon_type_chk_2') { // %
      this.couponDetails.discount_type_id = 2;
    } else {  // BOGO
      this.couponDetails.discount_type_id = 3;
    }

    this.couponDetails.dollar_discount_compare = 0;
    this.couponDetails.discount_value_lower = '';
    this.couponDetails.discount_value_upper = '';
  }

  // On Alcohol Coupon Type Click
  onAlcoholCouponTypeClick(event: any) {
    if (event.target.checked == false) {
      this.couponDetails.dollar_discount_compare = 0;
    } else {
      this.couponDetails.dollar_discount_compare = 1;
    }

    this.couponDetails.discount_value_lower = '';
    this.couponDetails.discount_value_upper = '';
  }

  // On image select
  onImageSelect(event) {
    // Remove files if exists
    if(this.couponImageFiles && this.couponImageFiles.length >=1) {
      this.onImageRemove(this.couponImageFiles[0]);
    }

    //this.couponImageFiles.push(...event.addedFiles[0]);
    this.couponImageUpload(event.addedFiles[0]);
  }

  // On image remove
  onImageRemove(event) {
    this.couponImageFiles.splice(this.couponImageFiles.indexOf(event), 1);

    this.couponDetails.uploadedImage =  '';
  }

  // Coupon image upload
  couponImageUpload(file: any){
    const file_size: any = file.size;
    const file_name: any = file.name.split('.');

    if ((file_size / 1000) > 50) { // > 50 Kb
      this._utilService.showToast('Please select an image with size less than 50Kb', '', 'warning', {});
    } else if (file_name.length > 2) {
      this._utilService.showToast("Image file name should not have '.' in it", '', 'warning', {});
    } else if (file_name.length === 2 && (file_name[1].toLowerCase() === "jpg" || file_name[1].toLowerCase() === "jpeg" || file_name[1].toLowerCase() === "png")) {
      // Upload image to S3
      /*let imageFolder: string = this.loginData.user_details.provider_type + this.loginData.user_details.provider_id + '/' + environment.s3_folder_coupons + '/';

      this.couponImageUploading = true;
      
      this._utilService.s3FileUpload(file, environment.s3_bucket, imageFolder, "").then(s3FileUploadResponse => {
        this.couponImageUploading = false;
        
        if (s3FileUploadResponse[0].status === true) { // Success
          this.couponDetails.uploadedImage = s3FileUploadResponse[0].data.Location; // Add image details to coupon details
          this.couponImageFiles.push(file); // Add to preview
        } else{
          this._utilService.showToast("Error while uploading coupon image", '', 'error', {});
        }
      });*/

      // Upload file to cloud storage
      let imageFolder: string = environment.cloud_storage_folder_prefix + '/' + this.loginData.user_details.provider_type + this.loginData.user_details.provider_id + '/' + environment.cloud_storage_folder_coupons;

      this.couponImageUploading = true;

      // Convert file to base64
      this._utilService.imageFiletoBase64(file, 1024).then(fileContents => {
        let uploadFileBody: any = {
          bucket: environment.cloud_storage_bucket,
          folder: imageFolder,
          fileType: file.type,
          base64Data: fileContents
        }
        
        // Upload file
        this._utilService.uploadFile(this.loginData.token, uploadFileBody).subscribe(async uploadFileResponse => {
          this.couponImageUploading = false;

          if (uploadFileResponse.status === true) { // Success
            this.couponDetails.uploadedImage = uploadFileResponse.file_name; // Add image details to coupon details
            this.couponImageFiles.push(file); // Add to preview
          } else {
            this._utilService.showToast("Error while uploading coupon image", '', 'error', {});
          }
        }, error => { // Error from createCircular
          this.couponImageUploading = false;
          this._utilService.showToast("Error while uploading coupon image", '', 'error', {});
        });
      }, error => {
        this._utilService.showToast(error, '', 'warning', {});
      });
    } else {
      this.couponImageUploading = false;
      this._utilService.showToast('Please select png or jpg image', '', 'warning', {});
    }
  }

  // On navigation click
  async onNavigationClick(action: string) {
    if (action == 'previous') {
      this.couponData.details = this.couponDetails;

      let responseSetStorageDataC_NEW_COUPON: any;
      if (this.module == 'CPG') {
        responseSetStorageDataC_NEW_COUPON = await this._utilService.setStorageData('C_NEW_COUPON', this.couponData);
      } else if (this.module == 'RETAILER') {
        responseSetStorageDataC_NEW_COUPON = await this._utilService.setStorageData('R_NEW_COUPON', this.couponData);
      }

      this.navigation.emit({ step: 2, button: action, status : true });
    } else if (action == 'next') {
      if (this.couponDetails.categories.length == 0) {
        this._utilService.showToast('Please select coupon category', '', 'warning', {});
      } else if (!this.couponDetails.manufacturer.mfg_id) {
        this._utilService.showToast('Please select coupon manufacturer', '', 'warning', {});
      } else if (!this.couponDetails.brand.brand_id) {
        this._utilService.showToast('Please select coupon brand', '', 'warning', {});
      } else if (!this.couponDetails.discount_type_id) {
        this._utilService.showToast('Please select coupon type', '', 'warning', {});
      } else {
        if (this.couponDetails.discount_type_id == 1) { // $
          if (this.couponDetails.dollar_discount_compare == 0) { // $ value
            if (!this.couponDetails.discount_value_lower) {
              this._utilService.showToast('Please enter coupon face value', '', 'warning', {});
              return false;
            } else if (this.couponDetails.discount_value_lower < 0) {
              this._utilService.showToast('Invalid coupon face value', '', 'warning', {});
              return false;
            } else { // Set discount value upper same as lower
              this.couponDetails.discount_value_upper = this.couponDetails.discount_value_lower;
            }
          } else { // Alcohol regular and offer $ value
            if (!this.couponDetails.discount_value_lower || !this.couponDetails.discount_value_upper) {
              this._utilService.showToast('Please enter coupon face value', '', 'warning', {});
              return false;
            } else if (this.couponDetails.discount_value_lower < 0 || this.couponDetails.discount_value_upper < 0) {
              this._utilService.showToast('Invalid coupon face value', '', 'warning', {});
              return false;
            }
          }
        } else if (this.couponDetails.discount_type_id == 2) { // %
          if (!this.couponDetails.discount_value_lower) {
            this._utilService.showToast('Please enter coupon face value', '', 'warning', {});
            return false;
          } else if (this.couponDetails.discount_value_lower < 0) {
            this._utilService.showToast('Invalid coupon face value', '', 'warning', {});
            return false;
          } else { // Set discount value upper same as lower
            this.couponDetails.discount_value_upper = this.couponDetails.discount_value_lower;
          }
        } else if (this.couponDetails.discount_type_id == 3) { // BOGO
          if (!this.couponDetails.discount_value_lower || !this.couponDetails.discount_value_upper) {
            this._utilService.showToast('Please enter coupon face value', '', 'warning', {});
            return false;
          } else if (this.couponDetails.discount_value_lower < 0 || this.couponDetails.discount_value_upper < 0) {
            this._utilService.showToast('Invalid coupon face value', '', 'warning', {});
            return false;
          }
        }

        if (!this.couponDetails.title) {
          this._utilService.showToast('Please enter coupon title', '', 'warning', {});
        } else if (!this.couponDetails.description) {
          this._utilService.showToast('Please enter coupon description', '', 'warning', {});
        } else if (!this.couponDetails.uploadedImage) {
          this._utilService.showToast('Please add coupon image', '', 'warning', {});
        } else { // Add selected details to storage
          this.couponData.details = this.couponDetails;

          let responseSetStorageDataC_NEW_COUPON: any;
          if (this.module == 'CPG') {
            responseSetStorageDataC_NEW_COUPON = await this._utilService.setStorageData('C_NEW_COUPON', this.couponData);
          } else if (this.module == 'RETAILER') {
            responseSetStorageDataC_NEW_COUPON = await this._utilService.setStorageData('R_NEW_COUPON', this.couponData);
          }

          this.navigation.emit({ step: 2, button: action, status : true });
        }
      }
    }
  }

}
